module.exports = __webpack_public_path__ + "static/waltz_roll_mini_4-0a9d21580eeb7a98bab98b00a9121edf.jpg";